<template>
  <div>
    <v-card color="grey lighten-4 my-3">
      <v-toolbar dense>
        <v-toolbar-title>Dikirim</v-toolbar-title>

        <v-spacer></v-spacer>
        <div class="pa-5">
          <v-text-field
            flat
            dense
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="hidden-sm-and-down"
          />
        </div>
      </v-toolbar>
    </v-card>
    <v-card v-for="pesanan in dataOrder" :key="pesanan.id" class="pa-3" width="100%">
      <v-row>
        <v-col>
          <div>No. Order</div>
          <div>
            <b>{{pesanan.No_Order}}</b>
          </div>
        </v-col>
        <v-col>
          <div>Kurir</div>
          <div>
            <b>{{pesanan.Kurir}}-{{pesanan.Service}}</b>
          </div>
        </v-col>
        <v-col>
          <div>Nomor Resi</div>
          <div>
            <b>{{pesanan.No_Resi}}</b>
          </div>
        </v-col>
        <v-col>
          <div>
            <v-chip class="ma-2" color="pink" label text-color="white">
              <v-icon left>mdi-label</v-icon>Dikirim
            </v-chip>
          </div>
        </v-col>
      </v-row>

      <v-divider></v-divider>
      <div v-for="barang in dataOrder" :key="barang.id">
        <v-row v-for="data in barang.Pesanan" :key="data.id">
          <v-col cols="2">
            <v-avatar size="100" tile>
              <img :src="getImageUrl(data.Gambar)" alt="John" />
            </v-avatar>
          </v-col>
          <v-col cols="10">
            <div>
              <b>{{data.Nama}}</b>
            </div>
            <div>{{data.Qty}} Barang ({{data.Berat}}kg)</div>
            <div>{{data.SubTotal | currency}}</div>
          </v-col>
        </v-row>
        <v-divider class="my-5"></v-divider>
        <div>
          <b>Data Pengiriman</b>
        </div>
        <div v-for="alamat in dataOrder" :key="alamat.alamat_id">
          <v-row>
            <v-col>
              <div class="my-1">Penerima</div>
              <div class="my-1">Alamat</div>
              <div class="my-1">Daerah Pengiriman</div>
            </v-col>
            <v-col>
              <div class="my-1">
                <b>{{alamat.Penerima}}</b>
                ({{alamat.PenerimaHp}})
              </div>
              <div class="my-1">{{alamat.Alamat}}</div>
              <div class="my-1">{{alamat.Provinsi}},{{alamat.Kota}},{{alamat.Kecamatan}}</div>
              <div class="my-1">{{alamat.KodePos}}</div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <!-- DIALOG -->
    <v-dialog v-model="kirim" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Masukkan Nomor Resi
          <v-spacer></v-spacer>
          <v-btn @click="kirim = false" icon color="green">
            <v-icon>fas fa-times-circle</v-icon>
          </v-btn>
        </v-card-title>
        <div class="pa-3">
          <v-form ref="resi" v-model="valid" lazy-validation>
            <v-text-field
              outlined
              v-model="noresi"
              :rules="[v => !!v || 'Item is required']"
              label="Nomor Resi"
              required
            ></v-text-field>
            <!-- <v-autocomplete
              v-model="kurir"
              :loading="loading"
              :items="listKurir"
              flat
              hide-no-data
              hide-details
              label="Pilih Kurir Pengiriman"
              solo-inverted
            ></v-autocomplete>-->
          </v-form>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deliver()">Kirim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      valid: true,
      noresi: null,
      kirim: false,
      kurir: null,
      listKurir: [],
      dataOrder: [],
      userid: localStorage.getItem("user_id")
    };
  },
  mounted() {
    this.getPesanan();
  },
  methods: {
    getPesanan() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/pengirim/" +
          this.userid +
          "/kirim"
      )
        .then(response => response.json())
        .then(data => {
          this.dataOrder = data.filter(d => d.No_Resi != null);
        });
    },
    detail(data) {
      this.inv_detail = data;
      this.invoice = true;
    },
    Pengiriman(data) {
      this.kirim = true;
      localStorage.setItem("no_order", data);
    },
    deliver() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/ProsesKirim?waybill=" +
          this.noresi +
          "&order=" +
          localStorage.getItem("no_order")
      )
        .then(response => response.json())
        .then(data => {
          if (data.status.code == 200) {
            Swal.fire("Good job!", "You clicked the button!", "success");
          } else {
            Swal.fire({
              icon: "error",
              title: "Invalid",
              text: "Resi Tidak Valid"
            });
          }
        });
    },

    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    }
  }
};
</script>